import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';

@Component({
  selector: 'app-fleet-management',
  standalone: true,
  imports: [
    CommonModule, 
    MatCardModule, 
    MatButtonModule, 
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule
  ],
  template: `
    <div class="fleet-management-container">
      <mat-card class="main-card">
        <mat-card-header>
          <mat-card-title>
            <mat-icon class="title-icon">directions_boat</mat-icon>
            Fleet Management
          </mat-card-title>
          <mat-card-subtitle>
            Comprehensive fleet management and vessel tracking
          </mat-card-subtitle>
        </mat-card-header>
        
        <mat-card-content>
          <p class="description">
            This module provides comprehensive fleet management capabilities including vessel registry, 
            license management, and fleet analytics. Monitor vessel activities, track compliance, 
            and manage fishing licenses efficiently.
          </p>
          
          <div class="management-grid">
            <div class="management-item">
              <mat-icon class="management-icon">boat</mat-icon>
              <h3>Vessel Registry</h3>
              <p>Manage vessel information and registration details</p>
            </div>
            
            <div class="management-item">
              <mat-icon class="management-icon">assignment</mat-icon>
              <h3>License Management</h3>
              <p>Track fishing licenses and permit compliance</p>
            </div>
            
            <div class="management-item">
              <mat-icon class="management-icon">analytics</mat-icon>
              <h3>Fleet Analytics</h3>
              <p>Analyze fleet performance and operational metrics</p>
            </div>
          </div>
        </mat-card-content>
        
        <mat-card-actions>
          <button mat-raised-button color="primary">
            <mat-icon>directions_boat</mat-icon>
            View Fleet
          </button>
          <button mat-button>
            <mat-icon>boat</mat-icon>
            Vessel Registry
          </button>
          <button mat-button>
            <mat-icon>assignment</mat-icon>
            License Management
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  `,
  styles: [`
    .fleet-management-container {
      padding: 2rem;
      max-width: 1200px;
      margin: 0 auto;
    }
    
    .main-card {
      margin-bottom: 2rem;
    }
    
    .title-icon {
      margin-right: 8px;
      color: #1976d2;
    }
    
    .description {
      color: #666;
      line-height: 1.6;
      margin-bottom: 2rem;
    }
    
    .management-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      gap: 1.5rem;
      margin-bottom: 2rem;
    }
    
    .management-item {
      text-align: center;
      padding: 1rem;
      border-radius: 8px;
      background: #f8f9fa;
      transition: transform 0.2s;
    }
    
    .management-item:hover {
      transform: translateY(-2px);
    }
    
    .management-icon {
      font-size: 2rem;
      width: 2rem;
      height: 2rem;
      color: #1976d2;
      margin-bottom: 0.5rem;
    }
    
    .management-item h3 {
      margin: 0.5rem 0;
      color: #333;
      font-size: 1.1rem;
    }
    
    .management-item p {
      margin: 0;
      color: #666;
      font-size: 0.9rem;
    }
    
    mat-card-actions {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
    }
    
    mat-card-actions button {
      display: flex;
      align-items: center;
      gap: 8px;
    }
    
    @media (max-width: 768px) {
      .fleet-management-container {
        padding: 1rem;
      }
      
      .management-grid {
        grid-template-columns: 1fr;
      }
      
      mat-card-actions {
        flex-direction: column;
      }
    }
  `]
})
export class FleetManagementComponent {
  constructor() {}
} 